export default "__VITE_ASSET__36m_8UZ3__"